export default "__VITE_ASSET__Gud121B3__"